<script setup lang="ts">
    import { computed, toRef } from 'vue'

    import type {
        AlternativeFilterReadModel,
        AlternativesViewReadModel
    } from '@Alternatives/AlternativesViews/Domain/readmodels'

    // ---------------- props / emits ----------------

    const props = defineProps<{
        propRm: AlternativeFilterReadModel
        propViews: AlternativesViewReadModel[]
    }>()

    const emit = defineEmits<{
        (e: 'deleteFilter', rm: AlternativeFilterReadModel): void
    }>()

    // ---------------- shortcuts ----------------

    const rm = toRef(props, 'propRm')
    const views = toRef(props, 'propViews')

    // ---------------- derived ----------------

    const headerText = computed<string | null>(() =>
    {
        if (!rm.value.Data || rm.value.Data.length === 0)
            return 'Invalid!'

        const selectedViews = views.value
            .filter(v => rm.value.Data.indexOf(v.Name) > -1)
            .map(v => v.Name)
            .sort()

        if (rm.value.Type === 'MemberOf')
            return `Member of: ${selectedViews.join(', ')}`

        if (rm.value.Type === 'NotMemberOf')
            return `Not a member of: ${selectedViews.join(', ')}`

        return null
    })

    // ---------------- methods ----------------

    function deleteFilter()
    {
        emit('deleteFilter', rm.value)
    }
</script>


<template>
    <div class="card" style="display: inline-block;">
        <div @click="rm.IsEdited = true" class="card-header pointer">
            {{headerText}}
        </div>
        <div v-if="rm.IsEdited" class="card-body">
            <div class="form-group">
                <label>Lists:</label>
                <select class="form-control" multiple size="6" v-model="rm.Data">
                    <option v-for="v in views" :value="v.Name">{{ v.Name }}</option>
                </select>
            </div>
            <div class="d-flex justify-content-between">
                <div class="dropdown d-inline">
                    <button type="button" class="btn btn-outline-danger" data-toggle="dropdown">
                        Delete
                    </button>
                    <div class="dropdown-menu">
                        <div class="btn-group">
                            <button type="button" class="btn btn-outline-secondary">Cancel</button>
                            <button @click="deleteFilter" type="button" class="btn btn-danger">Confirm</button>
                        </div>
                    </div>
                </div>

                <button @click="rm.IsEdited = false" class="btn btn-primary">Update</button>
            </div>
        </div>
    </div>
</template>